import { render, staticRenderFns } from "./housekeepingFeeConfigManage.vue?vue&type=template&id=5fe15fd4&scoped=true"
import script from "./housekeepingFeeConfigManage.vue?vue&type=script&lang=js"
export * from "./housekeepingFeeConfigManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingFeeConfigManage.vue?vue&type=style&index=0&id=5fe15fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe15fd4",
  null
  
)

export default component.exports